import { render } from "./DefaultPageView.vue?vue&type=template&id=4bf964f0"
import script from "./DefaultPageView.vue?vue&type=script&lang=js"
export * from "./DefaultPageView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__